import React from 'react';

export default function NoExecutionsScreen() {
  return (
    <div
      style={{
        fontWeight: 'bold',
        fontSize: 'clamp(1rem, 5vh, 2.5rem)',
        textAlign: 'center',
        padding: '1rem',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      You cant leave any review, try back later!
    </div>
  );
}
